import { render } from "./CollectionBlockOwner.vue?vue&type=template&id=00f35f0c&scoped=true&ts=true"
import script from "./CollectionBlockOwner.vue?vue&type=script&lang=ts"
export * from "./CollectionBlockOwner.vue?vue&type=script&lang=ts"

import "./CollectionBlockOwner.vue?vue&type=style&index=0&id=00f35f0c&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f35f0c"]])

export default __exports__